<template>
  <BottomPopup
    class="form-item-bottom-popup"
    :show="props.show"
    :title="props.title"
    borderRadius="20px"
    @onClose="onClose"
    @onSubmit="onSubmit"
  >
    <slot></slot>
  </BottomPopup>
  </template>
  <script lang="ts">
import vue from "../../../../../../../../adapter-vue";
import BottomPopup from "../../../../../../../common/BottomPopup";
const __sfc_main = {};
__sfc_main.props = {
  show: {
    key: "show",
    required: false,
    type: Boolean,
    default: false
  },
  title: {
    key: "title",
    required: false,
    type: String,
    default: ""
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    withDefaults,
    defineProps,
    defineEmits
  } = vue;
  const props = __props;
  const emits = __ctx.emit;
  function onClose() {
    emits("onClose");
  }
  function onSubmit() {
    emits("onSubmit");
  }
  return {
    props,
    onClose,
    onSubmit
  };
};
__sfc_main.components = Object.assign({
  BottomPopup
}, __sfc_main.components);
export default __sfc_main;
</script>
  <style scoped lang="scss"></style>
  